import wretch from 'wretch';

// API URL constants
export const ANNOUNCEMENT_API_URL = '/announcement';
export const AUTH_API_URL = '/authorization';
export const CLIENT_API_URL = '/clients';
export const MED_BILLING_API_URL = '/medbilling';
export const REFERENCE_API_URL = '/reference';

/** Singleton for base wretcher. Bearer token is added on login. */
export const fmhAPI = { base: wretch(process.env.REACT_APP_BASE_URL) };
